import type { Tracker } from '@archipro-website/tracker';

interface TrackTileMediaProps {
    itemID: number;
    itemType: string;
    itemName: string;
}

/**
 * Track the `TileMediaDetailClick` event. Triggers when a user clicks on a tile
 * to go to the detail page.
 */
// eslint-disable-next-line import/no-unused-modules
export const trackTileMediaDetailClick = (
    tracker: Tracker,
    props: TrackTileMediaProps
) => {
    tracker.log('TileMediaDetailClick', {
        url: new URL(window.location.href),
        label: props.itemName,
        data: {
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};
